"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("./");

var _luxon = require("luxon");

class Group {
  static thaw(groupObj) {
    if (groupObj == null) return null;
    const group = new Group();
    if (groupObj.id != null) group.setId(groupObj.id);
    if (groupObj.name != null) group.setName(groupObj.name);
    if (groupObj.contractExpiration != null) group.setContractExpiration(_luxon.DateTime.fromISO(groupObj.contractExpiration));
    if (groupObj.contractMaxEvaluations != null) group.setContractMaxEvaluations(groupObj.contractMaxEvaluations);
    if (groupObj.contractMaxEvaluators != null) group.setContractMaxEvaluators(groupObj.contractMaxEvaluators);
    if (groupObj.costPerEvaluation != null) group.setCostPerEvaluation(groupObj.costPerEvaluation);
    if (groupObj.evaluatorCostPerEvaluation != null) group.setEvaluatorCostPerEvaluation(groupObj.evaluatorCostPerEvaluation);
    if (groupObj.evalueeCanViewReport != null) group.setEvalueeCanViewReport(groupObj.evalueeCanViewReport);
    if (groupObj.logoUrl != null) group.setLogoUrl(groupObj.logoUrl);
    if (groupObj.reportsToId != null) group.setReportsToId(groupObj.reportsToId);
    if (groupObj.reportsTo != null) group.setReportsTo(Group.thaw(groupObj.reportsTo));
    if (groupObj.groupAssociations != null) group.setGroupAssociations(_.GroupAssociation.thawList(groupObj.groupAssociations));
    if (groupObj.invitations != null) group.setInvitations(_.GroupAssociation.thawList(groupObj.invitations));
    if (groupObj.ransactions != null) group.setTransactions(_.Transaction.thawList(groupObj.ransactions));
    if (groupObj.evaluations != null) group.setEvaluations(_.Evaluation.thawList(groupObj.evaluations));
    if (groupObj.admins != null) group.setAdmins(_.Person.thawList(groupObj.admins));
    if (groupObj.evaluators != null) group.setEvaluators(_.Person.thawList(groupObj.evaluators));
    if (groupObj.group != null) group.setGroup(Group.thawList(groupObj.group));
    if (groupObj.adminCount != null) group.setAdminCount(groupObj.adminCount);
    if (groupObj.evaluatorCount != null) group.setEvaluatorCount(groupObj.evaluatorCount);
    if (groupObj.evaluationCount != null) group.setEvaluationCount(groupObj.evaluationCount);
    if (groupObj.invitationCount != null) group.setInvitationCount(groupObj.invitationCount);
    if (groupObj.contactName != null) group.setContactName(groupObj.contactName);
    if (groupObj.contactEmail != null) group.setContactEmail(groupObj.contactEmail);
    if (groupObj.contactPhoneNumber != null) group.setContactPhoneNumber(groupObj.contactPhoneNumber);
    if (groupObj.addressId != null) group.setAddressId(groupObj.addressId);
    if (groupObj.address != null) group.setAddress(_.Address.thaw(groupObj.address));
    if (groupObj.isIndependent != null) group.setIsIndependent(groupObj.isIndependent);
    if (groupObj.isActive != null) group.setIsActive(groupObj.isActive); // if (groupObj.groupCostPerTraining != null) group.setGroupCostPerTraining(groupObj.groupCostPerTraining);
    // if (groupObj.evaluatorPaymentPercentagePerEvaluation != null) group.setEvaluatorPaymentPercentagePerEvaluation(groupObj.evaluatorPaymentPercentagePerEvaluation);
    // if (groupObj.evaluatorPaymentPerEvaluation != null) group.setEvaluatorPaymentPerEvaluation(groupObj.evaluatorPaymentPerEvaluation);
    // if (groupObj.timeToWaitBeforeRevokingEvaluationRequestOffer != null) group.setTimeToWaitBeforeRevokingEvaluationRequestOffer(groupObj.timeToWaitBeforeRevokingEvaluationRequestOffer);
    // if (groupObj.requestEvaluationPermissionRoles != null) group.setRequestEvaluationPermissionRoles(GroupRolePermission.thawList(groupObj.requestEvaluationPermissionRoles));
    // if (groupObj.scheduleEvaluationPermissionRoles != null) group.setScheduleEvaluationPermissionRoles(GroupRolePermission.thawList(groupObj.scheduleEvaluationPermissionRoles));
    // if (groupObj.viewResultsPermissionRoles != null) group.setViewResultsPermissionRoles(GroupRolePermission.thawList(groupObj.viewResultsPermissionRoles));
    // if (groupObj.purchaseProductsPermissionRoles != null) group.setPurchaseProductsPermissionRoles(GroupRolePermission.thawList(groupObj.purchaseProductsPermissionRoles));
    // if (groupObj.selectProductsPermissionRoles != null) group.setSelectProductsPermissionRoles(GroupRolePermission.thawList(groupObj.selectProductsPermissionRoles));

    return group;
  }

  static thawList(groupObjList) {
    if (groupObjList == null) return [];
    var groups = [];

    for (var i = 0; i < groupObjList.length; i++) {
      groups.push(Group.thaw(groupObjList[i]));
    }

    return groups;
  }

  static freeze(group) {
    if (group == null) return null;
    var groupObj = {};
    if (group.getId() != null) groupObj.id = group.getId();
    if (group.getName() != null) groupObj.name = group.getName();
    if (group.getContractExpiration() != null) groupObj.contractExpiration = group.getContractExpiration();
    if (group.getContractMaxEvaluations() != null) groupObj.contractMaxEvaluations = group.getContractMaxEvaluations();
    if (group.getContractMaxEvaluators() != null) groupObj.contractMaxEvaluators = group.getContractMaxEvaluators();
    if (group.getCostPerEvaluation() != null) groupObj.costPerEvaluation = group.getCostPerEvaluation();
    if (group.getEvaluatorCostPerEvaluation() != null) groupObj.evaluatorCostPerEvaluation = group.getEvaluatorCostPerEvaluation();
    if (group.getEvalueeCanViewReport() != null) groupObj.evalueeCanViewReport = group.getEvalueeCanViewReport();
    if (group.getLogoUrl() != null) groupObj.logoUrl = group.getLogoUrl();
    if (group.getReportsToId() != null) groupObj.reportsToId = group.getReportsToId();
    if (group.getReportsTo() != null) groupObj.reportsTo = Group.freeze(group.getReportsTo());
    if (group.getGroupAssociations() != null) groupObj.groupAssociations = _.GroupAssociation.freezeList(group.getGroupAssociations());
    if (group.getInvitations() != null) groupObj.invitations = _.GroupAssociation.freezeList(group.getInvitations());
    if (group.getTransactions() != null) groupObj.transactions = _.Transaction.freezeList(group.getTransactions());
    if (group.getEvaluations() != null) groupObj.evaluations = _.Evaluation.freezeList(group.getEvaluations());
    if (group.getAdmins() != null) groupObj.admins = _.Person.freezeList(group.getAdmins());
    if (group.getEvaluators() != null) groupObj.evaluators = _.Person.freezeList(group.getEvaluators());
    if (group.getGroup() != null) groupObj.group = Group.freezeList(group.getGroup());
    if (group.getAdminCount() != null) groupObj.adminCount = group.getAdminCount();
    if (group.getEvaluatorCount() != null) groupObj.evaluatorCount = group.getEvaluatorCount();
    if (group.getEvaluationCount() != null) groupObj.evaluationCount = group.getEvaluationCount();
    if (group.getInvitationCount() != null) groupObj.invitationCount = group.getInvitationCount();
    if (group.getContactName() != null) groupObj.contactName = group.getContactName();
    if (group.getContactEmail() != null) groupObj.contactEmail = group.getContactEmail();
    if (group.getContactPhoneNumber() != null) groupObj.contactPhoneNumber = group.getContactPhoneNumber();
    if (group.getAddressId() != null) groupObj.addressId = group.getAddressId();
    if (group.getAddress() != null) groupObj.adress = _.Address.freeze(group.getAddress());
    if (group.getIsIndependent() != null) groupObj.isIndependent = group.getIsIndependent();
    if (group.getIsActive() != null) groupObj.isActive = group.getIsActive(); // if (group.getGroupCostPerTraining() != null) groupObj.groupCostPerTraining = group.getGroupCostPerTraining();
    // if (group.getEvaluatorPaymentPercentagePerEvaluation() != null) groupObj.evaluatorPaymentPercentagePerEvaluation = group.getEvaluatorPaymentPercentagePerEvaluation();
    // if (group.getEvaluatorPaymentPerEvaluation() != null) groupObj.evaluatorPaymentPerEvaluation = group.getEvaluatorPaymentPerEvaluation();
    // if (group.getTimeToWaitBeforeRevokingEvaluationRequestOffer() != null) groupObj.timeToWaitBeforeRevokingEvaluationRequestOffer = group.getTimeToWaitBeforeRevokingEvaluationRequestOffer();
    // if (group.getRequestEvaluationPermissionRoles() != null) groupObj.requestEvaluationPermissionRoles = GroupRolePermission.freezeList(group.getRequestEvaluationPermissionRoles());
    // if (group.getScheduleEvaluationPermissionRoles() != null) groupObj.scheduleEvaluationPermissionRoles = GroupRolePermission.freezeList(group.getScheduleEvaluationPermissionRoles());
    // if (group.getViewResultsPermissionRoles() != null) groupObj.viewResultsPermissionRoles = GroupRolePermission.freezeList(group.getViewResultsPermissionRoles());
    // if (group.getPurchaseProductsPermissionRoles() != null) groupObj.purchaseProductsPermissionRoles = GroupRolePermission.freezeList(group.getPurchaseProductsPermissionRoles());
    // if (group.getSelectProductsPermissionRoles() != null) groupObj.selectProductsPermissionRoles = GroupRolePermission.freezeList(group.getSelectProductsPermissionRoles());

    return groupObj;
  }

  static freezeList(groups) {
    if (groups == null) return [];
    var groupObjList = [];

    for (var i = 0; i < groups.length; i++) {
      groupObjList.push(Group.freeze(groups[i]));
    }

    return groupObjList;
  }

  constructor() {
    this.setId(null);
    this.setName(null);
    this.setContractExpiration(null);
    this.setContractMaxEvaluations(null);
    this.setContractMaxEvaluators(null);
    this.setCostPerEvaluation(null);
    this.setEvaluatorCostPerEvaluation(null);
    this.setEvalueeCanViewReport(null);
    this.setLogoUrl(null);
    this.setReportsToId(null);
    this.setReportsTo(null);
    this.setGroupAssociations(null);
    this.setInvitations(null);
    this.setTransactions(null);
    this.setEvaluations(null);
    this.setAdmins(null);
    this.setEvaluators(null);
    this.setGroup(null);
    this.setAdminCount(null);
    this.setEvaluatorCount(null);
    this.setEvaluationCount(null);
    this.setInvitationCount(null);
    this.setContactName(null);
    this.setContactEmail(null);
    this.setContactPhoneNumber(null);
    this.setAddressId(null);
    this.setAddress(null);
    this.setIsIndependent(null);
    this.setIsActive(null); // this.setGroupCostPerTraining(null);
    // this.setEvaluatorPaymentPercentagePerEvaluation(null);
    // this.setEvaluatorPaymentPerEvaluation(null);
    // this.setTimeToWaitBeforeRevokingEvaluationRequestOffer(null);
    // this.setRequestEvaluationPermissionRoles(null);
    // this.setScheduleEvaluationPermissionRoles(null);
    // this.setViewResultsPermissionRoles(null);
    // this.setPurchaseProductsPermissionRoles(null);
    // this.setSelectProductsPermissionRoles(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setId(id) {
    this.id = id;
  }

  setName(name) {
    this.name = name;
  }

  setContractExpiration(contractExpiration) {
    this.contractExpiration = contractExpiration;
  }

  setContractMaxEvaluations(contractMaxEvaluations) {
    this.contractMaxEvaluations = contractMaxEvaluations;
  }

  setContractMaxEvaluators(contractMaxEvaluators) {
    this.contractMaxEvaluators = contractMaxEvaluators;
  }

  setCostPerEvaluation(costPerEvaluation) {
    this.costPerEvaluation = costPerEvaluation;
  }

  setEvaluatorCostPerEvaluation(evaluatorCostPerEvaluation) {
    this.evaluatorCostPerEvaluation = evaluatorCostPerEvaluation;
  }

  setEvalueeCanViewReport(evalueeCanViewReport) {
    this.evalueeCanViewReport = evalueeCanViewReport;
  }

  setLogoUrl(logoUrl) {
    this.logoUrl = logoUrl;
  }

  setReportsToId(reportsToId) {
    this.reportsToId = reportsToId;
  }

  setReportsTo(reportsTo) {
    this.reportsTo = reportsTo;
  }

  setGroupAssociations(groupAssociations) {
    this.groupAssociations = groupAssociations;
  }

  setInvitations(invitations) {
    this.invitations = invitations;
  }

  setTransactions(transactions) {
    this.transactions = transactions;
  }

  setEvaluations(evaluations) {
    this.evaluations = evaluations;
  }

  setAdmins(admins) {
    this.admins = admins;
  }

  setEvaluators(evaluators) {
    this.evaluators = evaluators;
  }

  setGroup(group) {
    this.group = group;
  }

  setAdminCount(adminCount) {
    this.adminCount = adminCount;
  }

  setEvaluatorCount(evaluatorCount) {
    this.evaluatorCount = evaluatorCount;
  }

  setEvaluationCount(evaluationCount) {
    this.evaluationCount = evaluationCount;
  }

  setInvitationCount(invitationCount) {
    this.invitationCount = invitationCount;
  }

  setContactName(contactName) {
    this.contactName = contactName;
  }

  setContactEmail(contactEmail) {
    this.contactEmail = contactEmail;
  }

  setContactPhoneNumber(contactPhoneNumber) {
    this.contactPhoneNumber = contactPhoneNumber;
  }

  setAddressId(addressId) {
    this.addressId = addressId;
  }

  setAddress(address) {
    this.address = address;
  }

  setIsIndependent(isIndependent) {
    this.isIndependent = isIndependent;
  }

  setIsActive(isActive) {
    this.isActive = isActive;
  } // setGroupCostPerTraining(groupCostPerTraining) {
  //   this.groupCostPerTraining = groupCostPerTraining;
  // }
  //
  // setEvaluatorPaymentPercentagePerEvaluation(evaluatorPaymentPercentagePerEvaluation) {
  //   this.evaluatorPaymentPercentagePerEvaluation = evaluatorPaymentPercentagePerEvaluation;
  // }
  //
  // setEvaluatorPaymentPerEvaluation(evaluatorPaymentPerEvaluation) {
  //   this.evaluatorPaymentPerEvaluation = evaluatorPaymentPerEvaluation;
  // }
  //
  // setTimeToWaitBeforeRevokingEvaluationRequestOffer(timeToWaitBeforeRevokingEvaluationRequestOffer) {
  //   this.timeToWaitBeforeRevokingEvaluationRequestOffer = timeToWaitBeforeRevokingEvaluationRequestOffer;
  // }
  //
  // setRequestEvaluationPermissionRoles(requestEvaluationPermissionRoles) {
  //   this.requestEvaluationPermissionRoles = requestEvaluationPermissionRoles;
  // }
  //
  // setScheduleEvaluationPermissionRoles(scheduleEvaluationPermissionRoles) {
  //   this.scheduleEvaluationPermissionRoles = scheduleEvaluationPermissionRoles;
  // }
  //
  // setViewResultsPermissionRoles(viewResultsPermissionRoles) {
  //   this.viewResultsPermissionRoles = viewResultsPermissionRoles;
  // }
  //
  // setPurchaseProductsPermissionRoles(purchaseProductsPermissionRoles) {
  //   this.purchaseProductsPermissionRoles = purchaseProductsPermissionRoles;
  // }
  //
  // setSelectProductsPermissionRoles(selectProductsPermissionRoles) {
  //   this.selectProductsPermissionRoles = selectProductsPermissionRoles;
  // }

  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  getContractExpiration() {
    return this.contractExpiration;
  }

  getContractMaxEvaluations() {
    return this.contractMaxEvaluations;
  }

  getContractMaxEvaluators() {
    return this.contractMaxEvaluators;
  }

  getCostPerEvaluation() {
    return this.costPerEvaluation;
  }

  getEvaluatorCostPerEvaluation() {
    return this.evaluatorCostPerEvaluation;
  }

  getEvalueeCanViewReport() {
    return this.evalueeCanViewReport;
  }

  getLogoUrl() {
    return this.logoUrl;
  }

  getReportsToId() {
    return this.reportsToId;
  }

  getReportsTo() {
    return this.reportsTo;
  }

  getGroupAssociations() {
    return this.groupAssociations;
  }

  getInvitations() {
    return this.invitations;
  }

  getTransactions() {
    return this.transactions;
  }

  getEvaluations() {
    return this.evaluations;
  }

  getAdmins() {
    return this.admins;
  }

  getEvaluators() {
    return this.evaluators;
  }

  getGroup() {
    return this.group;
  }

  getAdminCount() {
    return this.adminCount;
  }

  getEvaluatorCount() {
    return this.evaluatorCount;
  }

  getEvaluationCount() {
    return this.evaluationCount;
  }

  getInvitationCount() {
    return this.invitationCount;
  }

  getContactName() {
    return this.contactName;
  }

  getContactEmail() {
    return this.contactEmail;
  }

  getContactPhoneNumber() {
    return this.contactPhoneNumber;
  }

  getAddressId() {
    return this.addressId;
  }

  getAddress() {
    return this.address;
  }

  getIsIndependent() {
    return this.isIndependent;
  }

  getIsActive() {
    return this.isActive;
  } // getGroupCostPerTraining() {
  //   return this.groupCostPerTraining;
  // }
  //
  // getEvaluatorPaymentPercentagePerEvaluation() {
  //   return this.evaluatorPaymentPercentagePerEvaluation;
  // }
  //
  // getEvaluatorPaymentPerEvaluation() {
  //   return this.evaluatorPaymentPerEvaluation;
  // }
  //
  // getTimeToWaitBeforeRevokingEvaluationRequestOffer() {
  //   return this.timeToWaitBeforeRevokingEvaluationRequestOffer;
  // }
  //
  // getRequestEvaluationPermissionRoles() {
  //   return this.requestEvaluationPermissionRoles;
  // }
  //
  // getScheduleEvaluationPermissionRoles() {
  //   return this.scheduleEvaluationPermissionRoles;
  // }
  //
  // getViewResultsPermissionRoles() {
  //   return this.viewResultsPermissionRoles;
  // }
  //
  // getPurchaseProductsPermissionRoles() {
  //   return this.purchaseProductsPermissionRoles;
  // }
  //
  // getSelectProductsPermissionRoles() {
  //   return this.selectProductsPermissionRoles;
  // }

  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


}

exports.default = Group;